import { apiRequest } from 'api/apiClient';

const fetchWidgets = async ({
  page = 1,
  pageSize = 30,
  search = '',
  ordering = '',
  filters = {},
} = {}) => {
  const response = await apiRequest('GET', '/v1/widgets', null, {
    params: {
      page,
      page_size: pageSize,
      ...(search ? { search } : {}),
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });
  return response;
};

const fetchWidget = async (uid) => {
  const response = await apiRequest('GET', `/v1/widgets/${uid}`);
  return response;
};

const fetchWidgetPublic = async (uid) => {
  const response = await apiRequest('GET', `/v1/widgets/${uid}/public`);
  return response;
};

const WIDGETS_QUERIES = {
  FETCH_WIDGETS: fetchWidgets,
  FETCH_WIDGET: fetchWidget,
  FETCH_WIDGET_PUBLIC: fetchWidgetPublic,
};

export default WIDGETS_QUERIES;
